import { Card, Col, Form, Input, Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const Facility = ({ getChildData }) => {
    const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("singleRequest:facility_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-6">
        <Col span={24}>
          <label className="font-medium text-[0.813rem] mb-4 flex">{t("singleRequest:at_which_facility_did_the_patient_receive_care")}</label>
        </Col>
        <Col span={12}>
          <Form.Item
            className="font-medium"
            name="SRfacilityname"
            label={t("singleRequest:facility_name_doctor_name") }
            onChange={(e) => callparent(e.target.value, "SRfacilityname")}
            rules={[{ required: true, max: 100, message: t("singleRequest:please_enter_facility_name_doctor_name")  }]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={12}></Col>
        <Col span={12}>
          <Form.Item
            label={t("singleRequest:facility_email")}
            name="SRFacility_Email"
            onChange={(e) => callparent(e.target.value, "SRFacility_Email")}
            rules={[
              { max: 100, message: t("singleRequest:please_enter_facility_email")},
              {
                type: "email",
                message: t("singleRequest:please_enter_valid_email"),
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="SRfphone"
            className="font-medium"
            label={t("singleRequest:facility_phone_number")}
            onChange={(e) => callparent(e.target.value, "SRFacilityPhoneNumber")}
            rules={[
              { max: 20, message: t("singleRequest:facility_please_enter_phone_number") },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="SRfaddress1"
            label={t("singleRequest:address_line_1")}
            onChange={(e) => callparent(e.target.value, "SRFacilityAddressLine1")}
            rules={[{ required: true, max: 150, message: t("singleRequest:please_enter_address") }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="SRfaddress2"
            className="font-medium"
            label={t("singleRequest:address_line_2")}
            onChange={(e) => callparent(e.target.value, "SRFacilityAddressLine2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="SRfcity"
            label={t("singleRequest:city")}
            onChange={(e) => callparent(e.target.value, "SRFacilityCity")}
            rules={[{ required: true, max: 50, message: t("singleRequest:please_enter_city_name") }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="SRfstate"
            label={t("singleRequest:state")}
            onChange={(e) => callparent(e.target.value, "SRFacilityState")}
            rules={[{ required: true, message: t("singleRequest:please_enter_state_name") }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="SRfzipcode"
            label={t("singleRequest:zip_code")}
            onChange={(e) => callparent(e.target.value, "SRFacilityZipCode")}
            rules={[
              {
                max: 8,
                required: true,
                message:  t("singleRequest:please_enter_zip_code"),
              },
              {
                pattern: /^[0-9]+$/, // Ensure only numeric characters
                message:  t("singleRequest:zip_code_must_be_numeric"),
              },
              {
                min: 5, // Minimum length of 5 characters
                message: t("singleRequest:zip_code_must_be_at_least_5_digits_long"),
              },
            ]}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default Facility;
